module.exports = __webpack_public_path__ + "img/folder-open.46bceae3.svg";